import { useI18n } from "@/i18n/I18nProvider";

const RefundPolicy = () => {
  const { t, tx } = useI18n();
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('legal.refund.title', 'Refund Policy')}</h1>
      <p className="text-gray-700 mb-4">{t('legal.refund.intro', 'Refund eligibility depends on service type, cancellation timing, and vendor confirmation. If you believe you are entitled to a refund, contact support with your booking details.')}</p>
      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">{t('legal.refund.cancellations_title', 'Cancellations')}</h2>
      <p className="text-gray-700 mb-4">{t('legal.refund.cancellations_body', 'Same-day cancellations may incur a fee. No-shows are generally non-refundable.')}</p>
      <p className="text-gray-600 mt-8">{tx('legal.last_updated', { date: today })}</p>
    </div>
  );
};

export default RefundPolicy;
